<button *ngIf="link && (active$ | async)"
    mat-button
    color="primary"
    (click)="handleAction()">
    {{ link.label }}
</button>
